/// <reference path="../../typings/tsd.d.ts" /> 
module warsApp.filters {
    
    export class ReadableFileSize implements IFilter {
        constructor(private documentService: services.DocumentService) { }

        public filter(input: string): string {
            if (!input) return 'N/A';
            var displayString = this.documentService.getFileSizeStringFilter(input);
            return displayString;
        }
    }
}

warsApp.registerFilter('ReadableFileSize', ["documentService"]);